/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Setting key
 */

export const SettingKey = {
    MAP_LAYER_BASE: 'MAP_LAYER_BASE',
    MAP_LAYER_DRAWLAYER_VISIBILITY: 'MAP_LAYER_DRAWLAYER_VISIBILITY',
    MAP_DISPLAY: 'MAP_DISPLAY',
} as const;

export type SettingKey = typeof SettingKey[keyof typeof SettingKey];



